import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MailingMailFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MAIL' htmlFor='input-mailingMail' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='mailingMail'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-mailingMail' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MailingMailFormGroup)
